const mockData = {
  "days": [
    {
      "date": "2025-06-15T10:00:00Z",
      "day": "Sunday",
      "places": null,
      "morning": [
        {
          "type": "FLIGHT",
          "start_time": "2025-06-15T7:00:00Z",
          "end_time": "2025-06-15T9:00:00Z",
          "source": {
            "country": "India",
            "city": "New Delhi"
          },
          "destination": {
            "country": "Italy",
            "city": "Rome"
          },
          "detail": {
            "name": "",
            "description": ""
          }
        }
      ],
      "afternoon": [
        {
          "type": "HOTEL",
          "start_time": "2025-06-15T12:00:00Z",
          "end_time": "2025-06-15T16:59:00Z",
          "source": {
            "country": "Italy",
            "city": "Rome"
          },
          "destination": {
            "country": "Italy",
            "city": "Rome"
          },
          "detail": {
            "name": "",
            "description": ""
          }
        }
      ],
      "evening": [
        {
          "type": "ACTIVITY",
          "start_time": "2025-06-15T17:00:00Z",
          "end_time": "2025-06-15T19:00:00Z",
          "source": {
            "country": "Italy",
            "city": "Rome"
          },
          "destination": {
            "country": "Italy",
            "city": "Rome"
          },
          "detail": {
            "name": "",
            "description": ""
          }
        }
      ],
      "overnight": [
        {
          "type": "Leisure",
          "start_time": "2025-06-15T00:00:00Z",
          "end_time": "2025-06-15T04:59:00Z",
          "source": {
            "country": "",
            "city": ""
          },
          "destination": {
            "country": "",
            "city": ""
          },
          "detail": {
            "name": "",
            "description": ""
          }
        }
      ]
    },
    {
      "date": "2025-06-20T10:00:00Z",
      "day": "Friday",
      "places": null,
      "morning": [
        {
          "type": "Leisure",
          "start_time": "2025-06-20T06:00:00Z",
          "end_time": "2025-06-20T10:00:00Z",
          "source": {
            "country": "",
            "city": ""
          },
          "destination": {
            "country": "",
            "city": ""
          },
          "detail": {
            "name": "",
            "description": ""
          }
        }
      ],
      "afternoon": [
        {
          "type": "HOTEL",
          "start_time": "2025-06-20T12:00:00Z",
          "end_time": "2025-06-20T16:59:00Z",
          "source": {
            "country": "Italy",
            "city": "Venice"
          },
          "destination": {
            "country": "Italy",
            "city": "Venice"
          },
          "detail": {
            "name": "",
            "description": ""
          }
        }
      ],
      "evening": [
        {
          "type": "ACTIVITY",
          "start_time": "2025-06-20T17:00:00Z",
          "end_time": "2025-06-20T19:00:00Z",
          "source": {
            "country": "Italy",
            "city": "Venice"
          },
          "destination": {
            "country": "Italy",
            "city": "Venice"
          },
          "detail": {
            "name": "",
            "description": ""
          }
        }
      ],
      "overnight": [
        {
          "type": "Leisure",
          "start_time": "2025-06-20T00:00:00Z",
          "end_time": "2025-06-20T04:59:00Z",
          "source": {
            "country": "",
            "city": ""
          },
          "destination": {
            "country": "",
            "city": ""
          },
          "detail": {
            "name": "",
            "description": ""
          }
        }
      ]
    }
  ]
};

export default mockData;